/* Private notification state is held in memory, never in browser storage. */
document.addEventListener('alpine:init', () => {
  Alpine.store('notifications', {
    enabled: false, preview: false, items: [], unread: 0, cursor: null,
    loading: false, error: '', busy: {}, epoch: 0, revision: 0, timer: null, pages: 1,
    welcomeView: false, welcomeSeen: false, welcomeIdentity: null, welcomeIdentityRequest: null,
    welcomeDismissPending: false, dismissingWelcome: false,
    init() {
      const root = document.querySelector('[data-notifications-enabled]');
      if (root?.dataset.cfAuth !== '1') return;
      this.preview = root.dataset.notificationsPreview === 'true' && root.dataset.notificationsEnabled !== 'true';
      this.enabled = this.preview || root.dataset.notificationsEnabled === 'true';
      if (!this.enabled) return;
      if (this.preview) {
        this.items = ['topic', 'reply', 'thread'].map((kind, i) => ({id: 'sample-' + i, kind, actor_name: ['Jamie (sample)', 'Morgan (sample)', 'Jamie (sample)'][i], topic_title: ['A topic you created', 'A comment you posted', 'A conversation you joined'][i], read: i === 2, preview: true, created_at: new Date(Date.now() - (i + 1) * 3600000).toISOString()}));
        this.items.push({ id: 'sample-likes', kind: 'like', liked_kind: 'topic', like_count: 3, topic_title: 'A topic you created (sample)', read: true, preview: true, created_at: new Date().toISOString() });
        this.unread = 2;
      }
      this.onVisibility = () => { clearTimeout(this.timer); if (!document.hidden) void this.refresh(); };
      this.onAuthLost = () => this.clear();
      this.onPageHide = () => { this.leaveWelcomeView(true); this.clear(false); };
      this.onPageShow = () => {
        if (this.enabled) {
          this.welcomeView = !!document.querySelector('.modl-cf__notifications')?.getClientRects().length;
          void this.refresh();
        }
      };
      document.addEventListener('visibilitychange', this.onVisibility);
      window.addEventListener('modl-auth-lost', this.onAuthLost);
      window.addEventListener('pagehide', this.onPageHide);
      window.addEventListener('pageshow', this.onPageShow);
      window.addEventListener('modl-profile-created', this.onPageShow);
      void this.refresh();
    },
    clear(disable = true) {
      this.epoch++; this.revision++; clearTimeout(this.timer);
      this.items = []; this.unread = 0; this.cursor = null; this.busy = {}; this.loading = false; this.error = '';
      this.welcomeView = false; this.welcomeSeen = false; this.welcomeIdentity = null; this.welcomeIdentityRequest = null;
      if (disable) { this.enabled = false; this.welcomeDismissPending = false; }
    },
    async api(path, options) {
      const response = await window.ModlCommunityAPI.request('/api/notifications' + path, options);
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(response.status === 404 ? 'Notifications are not connected yet.' : data.error || 'Could not update notifications. Please try again.');
      return data;
    },
    async refresh(append = false) {
      if (this.welcomeDismissPending && !this.dismissingWelcome) await this.dismissWelcome();
      if (!this.enabled || this.preview || this.loading || Object.keys(this.busy).length) return;
      const epoch = this.epoch, revision = this.revision;
      this.loading = true; clearTimeout(this.timer);
      try {
        let data, rows = append ? [...this.items] : [], cursor = append ? this.cursor : null;
        const pages = append ? 1 : this.pages;
        for (let page = 0; page < pages; page++) {
          data = await this.api(cursor ? '?cursor=' + encodeURIComponent(cursor) : '');
          rows.push(...data.notifications); cursor = data.next_cursor;
          if (!cursor) break;
        }
        if (epoch !== this.epoch || revision !== this.revision) return;
        this.items = [...new Map(rows.map(n => [n.id,n])).values()];
        this.cursor = cursor; if (append) this.pages++;
        this.unread = data.unread; this.error = '';
        this.observeWelcome();
      } catch (error) {
        if (epoch === this.epoch) this.error = error.message;
      } finally {
        if (epoch === this.epoch) {
          this.loading = false;
          if (this.enabled && !document.hidden) this.timer = setTimeout(() => this.refresh(), 30000);
        }
      }
    },
    more() { if (this.cursor) void this.refresh(true); },
    async mark(notice, read) {
      if (Object.keys(this.busy).length || !this.enabled) return false;
      if (notice.read === read) return true;
      const epoch = this.epoch;
      this.revision++; this.busy[notice.id] = true;
      try {
        const data = this.preview ? {unread: this.unread + (read ? -1 : 1)} : await this.api('/' + notice.id + '/read', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({read})});
        if (epoch !== this.epoch) return false;
        notice.read = read; this.unread = Math.max(0, data.unread); this.error = ''; return true;
      } catch (error) { if (epoch === this.epoch) this.error = error.message; return false; }
      finally { if (epoch === this.epoch) delete this.busy[notice.id]; }
    },
    async markAllRead() {
      if (!this.enabled || !this.unread || Object.keys(this.busy).length) return false;
      const epoch = this.epoch;
      this.revision++; this.busy.all = true;
      try {
        const data = this.preview ? {unread: 0} : await this.api('/read-all', {method: 'POST'});
        if (epoch !== this.epoch) return false;
        this.items.forEach(notice => { notice.read = true; });
        this.unread = Math.max(0, data.unread); this.error = ''; return true;
      } catch (error) { if (epoch === this.epoch) this.error = error.message; return false; }
      finally {
        if (epoch === this.epoch) { delete this.busy.all; if (!this.preview) void this.refresh(); }
      }
    },
    async open(notice) {
      if (notice.kind === 'welcome') return;
      if (await this.mark(notice, true)) window.dispatchEvent(new CustomEvent('modl-notification-open', {detail: {...notice}}));
    },
    enterWelcomeView() {
      this.welcomeView = true; this.observeWelcome();
    },
    observeWelcome() {
      if (!this.welcomeView || !this.items.some(n => n.kind === 'welcome')) return;
      this.welcomeSeen = true;
      if (!this.preview && !this.welcomeIdentity && !this.welcomeIdentityRequest) {
        const epoch = this.epoch;
        this.welcomeIdentityRequest = window.ModlCommunityAPI.session().then(identity => {
          if (epoch === this.epoch) this.welcomeIdentity = identity;
          return identity;
        }).catch(() => null);
      }
    },
    leaveWelcomeView(keepalive = false) {
      this.welcomeView = false;
      if (!this.welcomeSeen) return;
      this.welcomeSeen = false; this.welcomeDismissPending = true;
      void this.dismissWelcome(keepalive);
    },
    async dismissWelcome(keepalive = false) {
      if (!this.enabled || !this.welcomeDismissPending || this.dismissingWelcome) return;
      const epoch = this.epoch;
      this.dismissingWelcome = true; this.revision++;
      try {
        let data;
        if (this.preview) data = {unread: this.unread - this.items.filter(n => n.kind === 'welcome' && !n.read).length};
        else {
          // Prepare CSRF while the view is open so leaving can use a keepalive request.
          const identity = this.welcomeIdentity || await this.welcomeIdentityRequest || await window.ModlCommunityAPI.session();
          const response = await window.ModlCommunityAPI.request('/api/notifications/welcome/dismiss', {method: 'POST', keepalive}, identity);
          if (!response.ok) throw new Error('Welcome dismissal will retry.');
          data = await response.json();
        }
        if (epoch !== this.epoch) return;
        this.items = this.items.filter(n => n.kind !== 'welcome');
        this.unread = Math.max(0, data.unread); this.welcomeDismissPending = false;
      } catch { /* Keep the pending dismissal for the next refresh. */ }
      finally { this.dismissingWelcome = false; }
    },
    description(n) {
      if (n.kind === 'welcome') return 'You created a MODL account!';
      if (n.kind === 'like') return 'Your ' + (n.liked_kind || 'post') + ' received likes (' + n.like_count + (n.like_count === 1 ? ' like)' : ' likes)');
      return (n.actor_name || 'A member') + ({topic: ' commented on your topic', reply: ' replied to your comment', thread: ' replied to a comment you joined'}[n.kind] || ' replied'); },
    date(value) { return new Date(value).toLocaleString(undefined, {month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit'}); }
  });
});
